import { api } from "./api";

export interface IModel {
  id: number;
  display_name: string;
  provider: string;
  identifier: string;
}

const listModels = async (): Promise<IModel[]> => {
  const url = "/models";
  const response = await api.get(url);
  return response.data;
};

export const modelService = {
  listModels,
};
